import * as React from "react";
import { UNITY_ACCESS } from "../../constants/app";

const APPROVED_VIA_HOSTS = ["quintiles.service-now.com", "quintilestest.service-now.com"];

const FALLBACK_MESSAGE =
  "Need access to Unity? Contact your administrator to request access.";

export const validateViaUrl = (url: string): boolean => {
  if (typeof url !== "string" || url.length === 0) {
    return false;
  }
  try {
    const parsed = new URL(url);
    return parsed.protocol === "https:" && APPROVED_VIA_HOSTS.includes(parsed.hostname);
  } catch {
    return false;
  }
};

type Props = {
  viaUrl?: string;
  className?: string;
};

const GetAccessLink = ({ viaUrl, className }: Props) => {
  const resolvedUrl = viaUrl || UNITY_ACCESS.VIA_TICKET_URL;
  const isValidUrl = validateViaUrl(resolvedUrl);
  const wrapperClass = className ? `get-access-help ${className}` : "get-access-help";

  if (!isValidUrl) {
    return <p className={wrapperClass}>{FALLBACK_MESSAGE}</p>;
  }

  return (
    <p className={wrapperClass}>
      Need access to Unity?{" "}
      <a
        href={resolvedUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Submit a ticket for Unity access"
      >
        Click here
      </a>{" "}
      to submit a ticket for access.
    </p>
  );
};

export default GetAccessLink;
